import axios from 'axios';
import { put, takeLatest, call, cps } from 'redux-saga/effects';
import * as types from '../ActionTypes/ActivityActionTypes';
import { profile } from '../../BusinessLogic/Network/API/ProfileApi';
import { ActivityActionCreators } from '../ActionCreators/ActivityActionCreators';

export class ActivitySaga {
    static *getActivity({ meta: { userId, completionCallback } }) {
        try {
            const _profile = profile.create();
            const { data: response } = yield call(axios, _profile.getActivity(userId));

            let offsetId = 0,
                offsetDate = 0;

            if (response.data.length) {
                offsetId = response.data[response.data.length - 1].id;
                offsetDate = response.data[response.data.length - 1].created_at;
            }

            yield put(ActivityActionCreators.getProfileActivitySuccess(response.data, offsetId, offsetDate));
            yield cps(completionCallback);
        } catch (error) {
            yield put(ActivityActionCreators.getProfileActivityFailed(error));
        }
    }

    static *loadMoreActivity({ meta: { userId, offsetId, offsetDate } }) {
        try {
            const _profile = profile.create();
            const { data: response } = yield call(axios, _profile.getActivity(userId, offsetId, offsetDate));

            if (response.data.length) {
                let offsetId = response.data[response.data.length - 1].id;
                let offsetDate = response.data[response.data.length - 1].created_at;
                yield put(ActivityActionCreators.loadMoreActivitySuccess(response.data, offsetId, offsetDate));
            }
        } catch (error) {
            yield put(ActivityActionCreators.loadMoreActivityFailed(error));
        }
    }
}

export function* saga() {
    yield takeLatest(types.GET_PROFILE_ACTIVITY_REQUEST, ActivitySaga.getActivity);
    yield takeLatest(types.LOAD_MORE_ACTIVITY_REQUEST, ActivitySaga.loadMoreActivity);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/ActivitySaga.js